import { createSelector } from 'reselect';
import { getUserData, getOrganizations, getImpersonateOrgDialog, normalizeAccountTypeName, AGENCY_ACCOUNT } from '../selectors/user';

export const getPage = createSelector(
    [getUserData, getOrganizations, getImpersonateOrgDialog],
    (userData, organizations, impersonateDialog) => ({
        partnerName: userData.company_display_name,
        accountTypeReady: !!userData.account_type_name,
        isAgency: normalizeAccountTypeName(userData.account_type_name) === AGENCY_ACCOUNT,
        agencyName: userData.company_display_name,
        agencyId: userData.agency_id,
        organizations,
        loading: impersonateDialog.loading,
    })
);
